/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Content_WebsitesInputs */

const en_onboarding_content_websites = /** @type {(inputs: Onboarding_Content_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Websites, articles, blog posts`)
};

const es_onboarding_content_websites = /** @type {(inputs: Onboarding_Content_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitios web, artículos, publicaciones de blog`)
};

/**
* | output |
* | --- |
* | "Websites, articles, blog posts" |
*
* @param {Onboarding_Content_WebsitesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_content_websites = /** @type {((inputs?: Onboarding_Content_WebsitesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Content_WebsitesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_content_websites(inputs)
	return en_onboarding_content_websites(inputs)
});